import { Component, Input } from '@angular/core';
import { IArticuloDataSource, IArticulos, ICertificadoDeEstatutos, ICompareciente, IDatosBasicosSolicitud, IFacultadesDataSource, IHistorialDeActuacionesAnotaciones, ISocio } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia.model';

@Component({
  selector: 'app-estatutos-viewer',
  templateUrl: './estatutos-viewer.component.html',
  styleUrls: ['./estatutos-viewer.component.scss']
})
export class EstatutosViewerComponent {
    @Input() content!: ICertificadoDeEstatutos;
    @Input() datosBasicosSolicitud!: IDatosBasicosSolicitud;
    @Input() showHeader = true;

    public rut = '';
    public today = '';

    public comparecientesDataSource!: ICompareciente[];
    public comparecientesDisplayedColumns: string[] = [
        'rut',
        'nombre',
        'domicilio',
    ];

    public sociosDataSource!: ISocio[];
    public sociosDisplayedColumns: string[] = [
        'nombre',
        'monto',
        'porcentaje',
        'tipoAporte',
    ];

    public facultadesDataSource!: IFacultadesDataSource[];
    public facultadesDisplayedColumns: string[] = [
        'poderes',
    ];

    public articulosDataSource!: IArticuloDataSource[];
    public articulosDisplayedColumns: string[] = [
        'tipo',
        'glosa',
    ];

    public historialActuacionesAnotacionesDataSource!: IHistorialDeActuacionesAnotaciones[];
    public historialActuacionesAnotacionesDisplayedColumns: string[] = [
        'item',
        'fecha',
        'codigoVerificacion',
    ];


    ngOnInit(): void {
        this.setToday();
        this.setRut();

        this.comparecientesDataSource = this.content.Comparecientes || [];
        this.sociosDataSource = this.content.Socios || [];
        this.historialActuacionesAnotacionesDataSource = this.content.HistorialDeActuacionesAnotaciones || [];
        
        this.setFacultadesDataSource();
        this.setArticulosDataSource();
    }

    setRut() {
        this.rut = this.datosBasicosSolicitud.Rut + '-' + this.datosBasicosSolicitud.DV
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    setArticulosDataSource() {
        const articulosEntries = Object.entries(this.content.Articulos);

        this.articulosDataSource = articulosEntries.map(([key, value]) => ({
            tipo: this.humanizeTipoArticulos(key),
            glosa: value,
        }));
    }

    setFacultadesDataSource() {
        const facultades = this.content.Facultades || [];

        this.facultadesDataSource = facultades.map((facultad: string) => ({
            poder: facultad,
        }));
    }

    humanizeTipoArticulos(tipo: string): string {
        return tipo.replace(/([A-Z])/g, ' $1').trim();
    }
}
